import Highcharts from 'highcharts';

export const figure33 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'bar',
        height: '600px',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
  
      colors: ['#ed7d31','#5b9bd5'],
  
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
  
      plotOptions: {
        series: {
          borderWidth: 0,
          marker: {
            symbol: 'circle',
            enabled: false,
            states: {
              hover: {
                enabled: true,
                radius: 5
              }
            }
          }
        }
      },
  
      exporting: {
        enabled: false
      },

      xAxis: [{
        categories: [
          "Mundo",
"Asia sudoriental",
"Asia oriental",
"Oceanía (excluidas Australia y Nueva Zelandia)",
"Australia y Nueva Zelandia",
"América Latina y el Caribe",
"África subsahariana",
"África septentrional",
"Asia occidental",
"América del Norte y Europa",
"Asia central",
"Asia meridional",
        ],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          }
        },
      }],
      yAxis: [{
        labels: {
          format: '{value}',
          formatter: function () {
            // should be return this.value + '.00%'; but doesn't fit
            return this.value + '%';
        },
        style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          },
        },
        max: 120,
        min: 0,
        tickInterval: 20,
        gridLineWidth: 2,
        title: {
          text: null,
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        }
      }],
      tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
          padding: 0
        }
      },
      legend: {
        enabled: false,
      },
  
      series: [{
        name: '2018',
        dataLabels: {
          enabled: false,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
        },
        data: [18.41, 20.75, 45.62, 0.16, 5.89, 6.56, 6.07, 108.55, 60.23, 12.34, 79.53, 77.73],
      },
      {
        name: '2015',
        dataLabels: {
          enabled: false,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
        },
        data:[18.18, 20.17, 45.65, 0.16, 7.31, 6.1, 5.9, 105.07, 57.9, 12.36, 76.68, 78.05] 
      }
    ]
}